import script from "./generate-payment-history.vue?vue&type=script&setup=true&lang=js"
export * from "./generate-payment-history.vue?vue&type=script&setup=true&lang=js"

import "./generate-payment-history.vue?vue&type=style&index=0&id=3126f34a&scoped=true&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3126f34a"]])

export default __exports__